export type Location = {
  id: number;
  loc_name: string;
  loc_street: string;
  loc_city: string;
  state: string;
  loc_country: string;
  is_active: boolean;
  timezone_name: string;
  functions: Array<() => void>;
  yard_config?: any;
  created_at: string;
};

export type LocationFormData = {
  name: string;
  street: string;
  city: string;
  state: string;
  country: string;
  timezoneName: string;
  isActive: boolean;
  functions: Array<() => void>;
};

export type LocationPostData = {
  loc_name: string;
  loc_street: string;
  loc_city: string;
  state: string;
  loc_country: string;
  timezone_name: string;
  is_active: boolean;
};

export const timezones = [
    {
        optionLabel: 'America/Los_Angeles', 
        optionValue: 'America/Los_Angeles',
    }, 
    {
        optionLabel: 'America/Mexico_City',
        optionValue: 'America/Mexico_City'
    },
    {
        optionLabel: 'America/Monterrey',
        optionValue: 'America/Monterrey'
    },
]